// extracted by mini-css-extract-plugin
export var heroImage = "_c2-1";
export var modal = "_c2-0";